export default "__VITE_ASSET__B0dQx3XI__"